import Swiper from 'swiper';
import { Navigation, Manipulation, FreeMode } from 'swiper/modules';

import {isMobileTabletCheck} from './module_common';

import {tocWrapSelector} from './module_player_new';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/manipulation';
import 'swiper/css/free-mode';

let params = {
    start: 0,
    onChapterChangeFunc: ()=>{},
}

export const carouselOutClass = "reader-out";
const outSelector = "."+carouselOutClass;
const currentChapterSelector = ".current-chapt"

const mobileHidePlayerOnScroll = 350;

function readerCarousel(){
    const containerSelector = ".reader-container"
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return
    const startChapter = $(outSelector).data("startchapt")

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation],
        slidesPerView: 1,
        spaceBetween: 16,
        watchSlidesProgress: true,
        autoHeight: true,
        navigation: {
            nextEl: outSelector + ' .swiper-next',
            prevEl: outSelector + ' .swiper-prev',
        },
        allowTouchMove: false,
        initialSlide: startChapter,
        on: {
            init: function (sw) {
                
            },
        }
    });

    window.swiper = swiper

    swiper.on('activeIndexChange', function(){
        const topMarkEl = $(".top-end-separator-mark");
        const navEl = $(".navbar.autohide")
        const removeSomeWhite = 20
        let mobileHidePlayer = 0
        if (isMobileTabletCheck()) {
            $(tocWrapSelector).collapse("hide")
            mobileHidePlayer = mobileHidePlayerOnScroll
        }
        $("html, body").animate({ scrollTop: (topMarkEl.offset().top) - navEl.outerHeight() + removeSomeWhite + mobileHidePlayer});

        params.onChapterChangeFunc(swiper.activeIndex)
    })
}

export const getStartChapter = function(){
    return $(outSelector).data("startchapt")
}

export const getChaptersLength = function(){
    return $(outSelector).data("chapterslength")
}

export function setReaderCurrentChapter(chapt){
    // bottom reader indicator "$chapt of TOT"
    $(currentChapterSelector).html(chapt)
}

export function initReader(initParams){
    params = initParams
    readerCarousel()
    setReaderCurrentChapter(params.readerCurrentChapter)
}